import { random } from 'underscore';
import { addMiddleware, removeMiddleware } from 'redux-dynamic-middlewares';
import { throttledRefresh } from 'bv-services/account-balance';
import { BetUpdateType } from 'SharedComponents/my_bets/constants';
import { subscribeToBets } from 'SharedComponents/my_bets/subscribers';

const balanceUpdaterMiddleware = (store) => (next) => (action) => {
  if (action.type === 'routing/REFRESH_CURRENT_PATH') {
    const oldPath = store.getState().routing.currentPath;
    next(action);
    const { currentPath } = store.getState().routing;

    // if we are navgiating from a cashier page to a non-cashier page by path
    if (oldPath.match(/bv_cashier/) && !currentPath.match(/bv_cashier/)) {
      setTimeout(throttledRefresh, 2000);
    }
  } else {
    next(action);
  }
};

export default () => {
  if (!throttledRefresh) return () => {};

  const unregisterBetsHandler = subscribeToBets(({ betUpdateType }) => {
    setTimeout(throttledRefresh, betUpdateType === BetUpdateType.NEW ? 0 : random(1000, 3000));
  });

  addMiddleware(balanceUpdaterMiddleware);

  return () => {
    unregisterBetsHandler();
    removeMiddleware(balanceUpdaterMiddleware);
  };
};
